import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ProjectPage from './components/ProjectPage';

const Root = () => {
  const [project, setProject] = React.useState(null);

  React.useEffect(() => {
    // Fetch the project data
    fetch('/data/projects.json')
      .then(response => response.json())
      .then(data => {
        const projectCode = 'proj1'; // Replace with dynamic code if needed
        const foundProject = data.find(project => project.code === projectCode);
        setProject(foundProject);
      })
      .catch(error => {
        console.error('Error fetching project data:', error);
      });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route 
          path="/project/:code" 
          element={<ProjectPage project={project} />} 
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//         const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
//         navigator.serviceWorker.register(swUrl).then(registration => {
//             console.log('SW registered: ', registration);
//         }).catch(error => {
//             console.error('SW registration failed: ', error);
//         });
//     });
// }

reportWebVitals();
